import styled from "styled-components";

export const Wrapper = styled.div`
  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;
